import useConference from 'calls/hooks/useConference.js';

const useLocalParticipant = () => {
	return useConference().localParticipant;
};

export default useLocalParticipant;
